export default "__VITE_ASSET__fCLZldDL__"